export const CADASTRO_LOADING = 'CADASTRO_LOADING';
export const DADOS_PESSOAIS_SET = 'DADOS_PESSOAIS_SET';
export const DADOS_PESSOAIS_SITE = 'DADOS_PESSOAIS_SITE';
export const CONFIRMA_DIVISAO_IGUAL = 'CONFIRMA_DIVISAO_IGUAL';
export const DADOS_DATA_NASCIMENTO = 'DADOS_DATA_NASCIMENTO';
export const PESSOA_POLITICAMENTE_EXPOSTA = 'PESSOA_POLITICAMENTE_EXPOSTA';
export const SET_NUMERO_DA_SORTE = 'SET_NUMERO_DA_SORTE';
export const CADASTRO_CARTAO_LOADING = 'CADASTRO_CARTAO_LOADING';